import React from 'react';
import styles from './MatchSwitcher.module.scss';
//translations
import { tr } from '../../../utils/translations/translator';
import { useTranslation } from 'react-i18next';

export enum MatchForecastType {
  DEFAULT = 'DEFAULT',
  CUSTOM = 'CUSTOM',
}

interface MatchSwitcherProps {
  onClick: () => void;
  matchForecastType: MatchForecastType;
}

export const MatchSwitcher: React.FC<MatchSwitcherProps> = ({
  onClick,
  matchForecastType = MatchForecastType.DEFAULT,
}) => {
  const { t } = useTranslation();
  return (
    <div onClick={onClick} className={styles.MatchSwitcher}>
      <label>
        {matchForecastType === MatchForecastType.DEFAULT
          ? tr(t, `matchSwitcher_${MatchForecastType.CUSTOM}`)
          : tr(t, `matchSwitcher_${MatchForecastType.DEFAULT}`)}
      </label>
    </div>
  );
};
